import { AppDispatch, RootState } from '@/store';
import { updateScenarioSettings } from '@/store/storeSlice';
import { ScenarioSettings as TScenarioSettings } from '@/store/types';

import {
  Checkbox,
  HandleError,
  Input,
  Label,
  Textarea,
  Tooltip,
  useDebounceCallback,
} from '@data-products-and-ai/react-components';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SetParameters } from './components/SetParameters';
import { handleInputChange } from './helpers';
const initialForm = {
  title: '',
  description: '',
  parameters: [
    {
      Fixed_WaitOnBatchTimeAsFixedHours: 8,
      Variable_WaitOnBatchTimeAsProcessTimePercentage: 80,
      DropDown_WaitOnBatchTime: 1,
      DropDown_JobsPrioritisation: 3,
      DropDown_UseOfAdditionalEquipment: false,
      DropDown_UseEachPOStartDate: false,
      DropDown_FileSelection: 1,
      Batch_Fill_Grade_Percentage: 0.9,
      DropDown_Use_Storage: false,
      DropDown_Use_Personnel_Module: false,
      Batch_Grouping_Option: 2,
      DropDown_Worker_Pooling: 1,
      DropDown_Scrap_Trigger: 1,
      DropDown_Process_Time_Trigger: 1,
      DropDown_Scrap_Delete: false,
      Variable_Process_Time: false,
      DropDown_Use_Area_Calculation: false,
      DropDown_Storage_Blocking: false,
    },
  ],
  options: {},
  run_separated: false,
};

/**
 * ScenarioSettings Component
 * Renders a form for managing scenario settings with various input fields and controls
 * Manages form state and handles input changes, including debounced input changes
 * Dispatches updates to the scenario settings in the Redux store
 */
const ScenarioSettings = () => {
  const dispatch: AppDispatch = useDispatch();
  const selectedScenario = useSelector(
    (state: RootState) => state.store.Simulation,
  ).scenarios.find((item) => item.is_selected)?.settings;
  const sites = useSelector(
    (state: RootState) => state.store.Simulation.sites
  );

  const [form, setForm] = useState<TScenarioSettings>(
    selectedScenario || initialForm,
  );

  const handleInputChangeDebounced = useDebounceCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      handleInputChange(event, setForm);
    },
    1000,
  );

  useEffect(() => {
    dispatch(updateScenarioSettings({ settings: form }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  if (!form) return <></>;

  return (
    <>
      {/*  <pre>{JSON.stringify(form, null, 2)}</pre> */}

      <div style={{ width: '80%', margin: '0 auto', paddingTop: 20 }}>
        <form>
          <Label tag="textdefault">Title</Label>
          <HandleError mandatory mandatoryError="Title is mandatory">
            <Input
              maxLength={60}
              placeholder="Write a title for your scenario"
              id="title"
              defaultValue={form.title}
              onChange={(event) => handleInputChangeDebounced(event)}
            ></Input>
          </HandleError>
          <Label tag="textdefault" marginTop={30}>
            Description
          </Label>
          <Textarea
            id="description"
            defaultValue={form.description}
            onChange={(event) => handleInputChangeDebounced(event)}
          ></Textarea>
          {/* {sites.length > 1 && (
          <div style={{ marginTop: 30 }}>
            <Tooltip title="Run simulation setting separately for each site">
              <Checkbox
                id={`run_separated__checkbox}`}
                isChecked={form.run_separated}
                onChange={() =>
                  setForm((prevForm) => ({
                    ...prevForm,
                    run_separated: !prevForm.run_separated,
                  }))
                }
                label="Run separately"
              />
            </Tooltip>
          </div>)} */}
          <SetParameters form={form} setForm={setForm} />
        </form>
      </div>
    </>
  );
};

export default ScenarioSettings;
